const basicCustomerChargeRate = {
  name: 'Basic Customer Charge',
  rateElementType: 'FixedPerMonth',
  rateComponents: [
    {
      charge: 14.40,
      name: 'Basic Customer Charge',
    },
  ],
};
const summerEnergyCharge = {
  name: 'Summer Energy Charge',
  rateElementType: 'EnergyTimeOfUse',
  rateComponents: [
    {
      charge: 0.121533, // 12.1533¢ per kWh
      months: [6, 7, 8, 9], // June through September
      name: 'Energy Charge (June to September)',
    },
  ],
};
const winterEnergyCharge = {
  name: 'Winter Energy Charge',
  rateElementType: 'EnergyTimeOfUse',
  rateComponents: [
    {
      charge: .105123, // 10.5123¢ per kWh
      months: [10, 11, 0, 1, 2, 3, 4, 5], // October through May
      name: 'Energy Charge (October to May)',
    },
  ],
};
const fuelcostEnergyCharge = {
  name: 'Fuel Cost per kWh',
  rateElementType: 'EnergyTimeOfUse',
  rateComponents: [
    {
      charge: .00023033, // 0.023033¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Energy Charge (All Months)',
    },
  ],
};
const residentialRateNC = () => {
  return {
    name: 'Residential Service',
    title: 'Virginia Electric and Power Company NC Schedule 1',
    rateElements: [
      basicCustomerChargeRate,
      summerEnergyCharge,
      winterEnergyCharge,
	    fuelcostEnergyCharge
    ],
  }
};

export default residentialRateNC;
